import { useEffect, useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { useMusicPlayer } from './MusicPlayerContext';

/**
 * Compact music player that sits to the left of the chat input.
 * When the info icon is clicked, the track details extend upward.
 */
function ChatInlinePlayer() {
  const [infoExpanded, setInfoExpanded] = useState(false);
  const {
    isPlaying,
    currentTrack,
    loading,
    stop,
    handlePlayStop,
    handleNext,
    openTrackInTab,
  } = useMusicPlayer();

  useEffect(() => () => stop(), [stop]);

  const title = currentTrack?.title ?? '(no track playing)';
  const artist = currentTrack?.user?.name ?? '';
  const trackArtUrl = currentTrack?.artwork?.['480x480'] || currentTrack?.artwork?.['150x150'] || currentTrack?.artwork['1000x1000'];

  return (
    <div className="inline-player-player">
      <div className={`inline-player-player-controls${infoExpanded ? ' inline-player-player-controls--expanded' : ''}`}>
        <button
          type="button"
          className={`inline-player-play${loading ? ' inline-player-play--loading' : ''}${isPlaying ? ' inline-player-play--playing' : ''}`}
          aria-label={isPlaying ? 'Stop' : 'Play'}
          title={isPlaying ? "Pysäytä" : "Toista"}
          onClick={handlePlayStop}
          disabled={loading}
        >
          {loading ? (
            <span className="inline-player-spinner" aria-hidden="true" />
          ) : isPlaying ? (
            '■'
          ) : (
            '▶'
          )}
        </button>
        <button
          type="button"
          className="inline-player-next"
          aria-label="Next"
          onClick={handleNext}
          title="Seuraava"
          disabled={loading}
        >
          ›
        </button>
        <div className="inline-player-music-info">
          <button
            type="button"
            className="inline-player-info-icon"
            onClick={() => setInfoExpanded((e) => !e)}
            aria-label="Lisäinfo"
            aria-expanded={infoExpanded}
            title="Lisäinfo"
          >
            <span className="inline-player-info-i">i</span>
          </button>
          {infoExpanded && (
            <div
              className="inline-player-details"
              style={trackArtUrl ? { backgroundImage: `url(${trackArtUrl})` } : undefined}
            >
              <div className="inline-player-detail-row"><strong>{title}</strong></div>
              <div className="inline-player-detail-row">- <strong>{artist}</strong></div>
              <button
                type="button"
                className="inline-player-open-tab"
                onClick={openTrackInTab}
                aria-label="Open in another tab"
                title="Kuuntele Audiuksessa"
                disabled={!currentTrack?.permalink}
              > 
              <ExternalLink className="inline-player-open-tab-icon" size={24} strokeWidth={2} />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChatInlinePlayer;
